/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 28/07/13
 * Time: 09:22
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.controllers').controller('WebSiteHomeCtrl', ["$scope",
    function ($scope) {
        $scope.ad.view.currentCategoryView = $scope.ad.view.categoryRootView;
        $scope.ad.view.currentProductCategoryView = $scope.ad.view.productCategoryRootView;
        $scope.ad.view.currentCureCategoryView = $scope.ad.view.cureCategoryRootView;
        $scope.ad.view.currentLoyaltyCardCategoryView = $scope.ad.view.loyaltyCardCategoryRootView;
    }
]);



// WEBPACK FOOTER //
// ./js/controllers/customerSite/WebSiteHomeCtrl.js